module.exports = __webpack_public_path__ + "img/ico_rank_selling.9fa4b17.svg";